export default __webpack_public_path__ + "static/media/technology-banner.3a7f1db4.jpg";